module.exports = __webpack_public_path__ + "media/images/icons/clock-07fa14c4dcf1075b34ad2ffb9ea63fa2.svg";